import React from 'react';
import Plot from 'react-plotly.js';
import WaterMark from '../DashboardMain_Orion/WaterMark';
import styles from './EnergyPageCustom_Orion.module.css'

const GaugeChart_Orion = (props) => {
  const { range_end, range_main, title, gauge_color } = props

  const config = {
    scrollZoom: true,
    showLink: false,
    modeBarButtonsToRemove: ['toImage', 'zoom2d', 'pan', 'pan2d', 'autoScale2d'],
    displayLogo: false,
    displayModeBar: false
  };

  return (
    <>
      <WaterMark />
      <Plot
        className="custom-plot"
        data={[
          {
            type: 'indicator',
            mode: 'gauge+number',
            value: range_main,
            // title: {
            //   text: title, font: { size: 13, color: '#0E3157', weight: "bold" }
            // },
            gauge: {
              axis: { range: [null, range_end], tickwidth: 1, tickcolor: gauge_color },
              bar: { color: gauge_color },
              borderwidth: 2,
              bordercolor: 'gray',
              steps: [
                { range: [0, 100], color: gauge_color },
                { range: [0, 100], color: 'white' }
              ],
            }
          }
        ]}
        layout={{
          width: 260,
          height: 155,
          margin: { t: 0, b: 0, r: 20, l: 20 },
          annotations: [{
            text: "Kwh/Km", // Text to display under the value
            font: { size: 12, color: '#0E3157' },
            showarrow: false,
            x: 0.5,
            y: 0.05
          }],
        }}
        config={config}
      />
    </>
  );
};

export default GaugeChart_Orion;
